var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import styled from 'styled-components';
export var Input = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-grow: 1;\n  min-height: 46px;\n  padding: 0 1px;\n  width: 100%;\n"], ["\n  display: flex;\n  flex-grow: 1;\n  min-height: 46px;\n  padding: 0 1px;\n  width: 100%;\n"])));
export var Control = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
export var Accessories = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  line-height: 46px;\n  display: inline;\n  color: ", ";\n\n  &:first-child {\n    margin: 0 0 0 16px;\n  }\n\n  &:last-child {\n    margin: 0 16px 0 0;\n  }\n"], ["\n  line-height: 46px;\n  display: inline;\n  color: ", ";\n\n  &:first-child {\n    margin: 0 0 0 16px;\n  }\n\n  &:last-child {\n    margin: 0 16px 0 0;\n  }\n"])), function (_a) {
  var theme = _a.theme,
    error = _a.error;
  return error ? theme.tokens.text.label.negative : theme.tokens.text.label.regular;
});
var templateObject_1, templateObject_2, templateObject_3;